import yup from 'utils/yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useState, useContext, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { IBuyerUserForList } from 'domain/entities/BuyerUser/BuyerUser';
import { BuyerMemberQuery } from 'interfaceAdapter/queries/BuyerMember';
import { InviteBuyerUserRepository } from 'interfaceAdapter/repositories/InviteBuyerUser';
import { useModal } from 'ui/components/screens/modals/useModal';

const schema = yup
    .object({
        email: yup.string().email().required(),
    })
    .required();

type inviteForm = yup.InferType<typeof schema>;

export const useMember = () => {
    const diContainer = useContext(diContainerContext);
    const buyerMemberQuery = diContainer.resolve(BuyerMemberQuery);
    const inviteBuyerUserRepository = diContainer.resolve(InviteBuyerUserRepository);
    const [memberList, setMemberList] = useState<IBuyerUserForList[]>([]);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const inviteModal = useModal();
    const needProfileModal = useModal();

    const {
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm<inviteForm>({
        resolver: yupResolver(schema),
        mode: 'onChange',
        defaultValues: {
            email: '',
        },
    });

    useEffect(() => {
        const fetchData = async () => {
            const data = await buyerMemberQuery.fetchList();
            setMemberList(data);
        };
        fetchData();
    }, []);

    const invite = handleSubmit(async (data) => {
        await inviteBuyerUserRepository.post(data.email);
        inviteModal.closeModal();
        setShowSnackbar(true);
    });

    return { memberList, showSnackbar, inviteModal, needProfileModal, errors, setShowSnackbar, setValue, invite };
};
